import { categories } from '@/mocks/gossipData';

const iconTone = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-600',
  'bg-secondary-200 text-secondary-900',
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-600',
  'bg-secondary-200 text-secondary-900',
];

export default function Topics() {
  return (
    <section id="topics" className="scroll-mt-20 bg-foreground-950">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-semibold tracking-wide text-background-200">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
              话题分类 · 瓜田地图
            </div>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-[2rem]">
              你想吃的瓜，都在哪一片
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-background-300 md:text-base">
              每个吃瓜方向单独成区，点进去就能看到该方向昨日的集中盘点与精华讨论，不用在庞杂信息里大海捞针。
            </p>
          </div>
          <a
            href="#essence"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap self-start rounded-full border border-background-50/20 px-4 py-2 text-sm font-semibold text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300 lg:self-auto"
          >
            查看精华盘点 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <a
              key={c.name}
              href="#essence"
              className="group flex items-center gap-4 rounded-2xl bg-background-100 p-5 transition-all hover:-translate-y-0.5 hover:bg-background-50"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${iconTone[i % iconTone.length]}`}
              >
                <i className={`${c.icon} text-xl`} />
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-1 truncate text-xs text-foreground-500">{c.desc}</p>
                <p className="mt-1 text-[11px] font-semibold text-accent-600">{c.count}</p>
              </div>
              <i className="ri-arrow-right-up-line text-xl text-secondary-400 transition-colors group-hover:text-primary-600" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}